var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoticeSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0004 19.5984C15.3023 19.5984 19.6004 15.3004 19.6004 9.99844C19.6004 4.6965 15.3023 0.398438 10.0004 0.398438C4.69846 0.398438 0.400391 4.6965 0.400391 9.99844C0.400391 15.3004 4.69846 19.5984 10.0004 19.5984ZM14.4489 8.44697C14.9175 7.97834 14.9175 7.21854 14.4489 6.74991C13.9803 6.28128 13.2205 6.28128 12.7519 6.74991L8.80039 10.7014L7.24892 9.14991C6.78029 8.68128 6.02049 8.68128 5.55186 9.14991C5.08323 9.61854 5.08323 10.3783 5.55186 10.847L7.95186 13.247C8.42049 13.7156 9.18029 13.7156 9.64892 13.247L14.4489 8.44697Z",
    fill: "#148757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeSuccessIcon);
export default __webpack_public_path__ + "static/media/NoticeSuccessIcon.d1315b16677a46490f9288b618232ab1.svg";
export { ForwardRef as ReactComponent };